<template>
  <section class="modal-card-body" :data-test="testId">
    <carfax-model-reconcile
      ref="reconcile"
      :selectedMakeModel="selectedMakeModel"
      :carfaxMakeModel="decodedMakeModel"
      :selectedMake="selectedMake"
      :sourceLabel="sourceLabel"
      :candidates="candidates"
      :customMessage="message"
      v-on:choice-changed="$emit('choice-changed', $event)"
      v-on:apply="$emit('apply', $event)"
      v-on:cancel="$emit('cancel')">
    </carfax-model-reconcile>
    <!-- ⚠ Apply is DISABLED until a row is ticked. The prompt pre-checks nothing - on inventory there
         is no current model to fall back on, which is the whole point - so an enabled Apply would
         close it having applied null. The buttons live here rather than in CarfaxModelReconcile
         because its other host, NewInventory, keeps them in its own modal chrome. -->
    <div class="buttons decoded-model-choice-actions">
      <button class="button is-primary" type="button" :data-test="testId + '-apply'" :disabled="!canApply" @click="onApplyClick">Apply</button>
      <button class="button is-danger" type="button" :data-test="testId + '-cancel'" @click="$emit('cancel')">Cancel</button>
    </div>
  </section>
</template>

<script>
/*
 * The VIN decode's model-group prompt, as a panel.
 *
 * ⚠ It exists to stop the block being written FOUR times. Both make/model selectors carry two layout
 * blocks each (a modal and an inline panel), and the markup is identical in all four. The selectors
 * are already a 94% copy of one another; four hand-maintained copies of this is how the two of them
 * came to solve the same model-group bug in two different ways.
 *
 * ⚠ Presentational only. It owns no state and decides nothing - the decision lives in the
 * decodedModelChoice mixin, and every interaction is re-emitted to the host that mixed it in.
 */
import CarfaxModelReconcile from '@/components/generic/CarfaxModelReconcile'

export default {
  name: 'DecodedModelChoicePanel',
  components: {
    'carfax-model-reconcile': CarfaxModelReconcile
  },
  props: {
    // The record's current vehicle selection, so the prompt can show what is already there.
    selectedMakeModel: {
      type: Object,
      default: null
    },
    // The decode shaped as a make/model - the mixin's decodedModelChoiceMakeModel.
    decodedMakeModel: {
      type: Object,
      default: null
    },
    // The catalogue make, so the candidate rows can be found.
    selectedMake: {
      type: Object,
      default: null
    },
    message: {
      type: String,
      default: ''
    },
    /*
     * ⚠ Three pass-throughs, every one defaulting to what this panel hardcoded before, so the VIN
     * decode hosts are unchanged without passing anything. They exist because the TYPED-model prompt
     * reuses this panel: it names its source differently, supplies its own substring-matched
     * candidates, and needs its own test hooks so a bug that rendered both prompts at once would be
     * visible rather than ambiguous.
     */
    sourceLabel: {
      type: String,
      default: 'VIN decode'
    },
    candidates: {
      type: Array,
      default: null
    },
    testId: {
      type: String,
      default: 'decoded-model-choice'
    },
    canApply: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /*
     * ⚠ Reaches into the child rather than holding the chosen row here. CarfaxModelReconcile owns
     * which row is ticked; NewInventory's copy of these buttons does the same
     * (`@click="$refs.carfaxModelReconcile.onApply()"`), and following that keeps one pattern.
     */
    onApplyClick: function () {
      if (this.$refs.reconcile) this.$refs.reconcile.onApply()
    }
  }
}
</script>

<style scoped>
  .decoded-model-choice-actions {
    margin-top: 12px;
  }
</style>
